import { render, staticRenderFns } from "./PurchaseRequestList.vue?vue&type=template&id=618c75a5&"
import script from "./PurchaseRequestList.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports